import { modalZIndex } from '../../../../contexts/PropertyPageModalContext/PropertyPageModalContext';
import { DisclaimerButton } from '../../BeforeYouBuyModal.styled';
import { Tooltip } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';

const BeforeYouBuyThirdPartyDisclaimerText: FunctionComponent = () => {
  return (
    <>
      <p>
        Realestate.com.au Pty Ltd partners with a number of third party product providers to help
        meet your needs. If you obtain those products, we may receive remuneration (such as a flat
        fee or commission). Although we might refer you to third party product providers, we do not
        endorse or otherwise take any responsibility for the products or services they provide to
        you. If you have any questions about our arrangements with third party product providers,
        please don&apos;t hesitate to ask a customer service representative and they can provide you
        with more information.
      </p>
      <p>We recommend that you conduct your own inquiries before purchasing.</p>
    </>
  );
};

export const BeforeYouBuyThirdPartyDisclaimer: FunctionComponent = () => {
  return (
    <Tooltip
      dangerouslySetClassNames={{
        tooltipContainer: 'tooltipContainer',
        contentWrapper: 'contentWrapper',
        closeButtonWrapper: 'closeButtonWrapper',
        closeButton: 'closeButton',
        triggerButton: 'triggerButton',
        icon: 'icon',
        elementPopoverClassNames: {
          overlay: 'elementPopover-overlay',
        },
      }}
      zIndex={modalZIndex + 1}
      placement="top"
      trigger={({ toggle }) => (
        <DisclaimerButton type="button" onClick={toggle}>
          Disclaimer for third party products
        </DisclaimerButton>
      )}
    >
      <BeforeYouBuyThirdPartyDisclaimerText />
    </Tooltip>
  );
};
